import {gql} from '@apollo/client/core';
import {CustomerProfileAddressFragment} from './checkout.fragment';

export const CustomerProfileFragment = gql`
  fragment customerProfile on CustomerProfile {
    id
    emailForOrderConfirmation
    fullName
    superpayUUID
    phoneNumber
    isEmailConfirmed
    hasPassword
    accountType
    ageVerificationStatus
    ageVerificationId
    deliveryComment
    dob
    cvr
    ean
    vismaId
    companyName
    reviews {
      rating
      product {
        id
        vismaProductNumber
      }
    }
    wishlist {
      id
      vismaProductNumber
    }
    addresses {
      ...customerProfileAddress
    }
  }
  ${CustomerProfileAddressFragment}
`;
